const DEFAULT_COLORS = [
  { value: "White", label: "White", hex: "#efefef" },
  { value: "Silver", label: "Silver", hex: "#aaa9ad" },
  { value: "Beige", label: "Beige", hex: "#f5f5dc" },
  { value: "Grey", label: "Grey", hex: "#808080" },
  { value: "Gold", label: "Gold", hex: "#d4af37" },
  { value: "Yellow", label: "Yellow", hex: "#ffff00" },
  { value: "Orange", label: "Orange", hex: "#ffa500" },
  { value: "Red", label: "Red", hex: "#ff0000" },
  { value: "Pink", label: "Pink", hex: "#ffc0cb" },
  { value: "Purple", label: "Purple", hex: "#800080" },
  { value: "Blue", label: "Blue", hex: "#0000ff" },
  { value: "Green", label: "Green", hex: "#008000" },
  { value: "Brown", label: "Brown", hex: "#964b00" },
  { value: "Black", label: "Black", hex: "000000" }
];


/**
 * Return an array of objects
 */
export function getColors() {
  return DEFAULT_COLORS;
}
